import { Component } from '@opten/compiler/metadata/component';
import hasClass from '@opten/dom/has-class';
import removeClass from '@opten/dom/remove-class';
import addClass from '@opten/dom/add-class';
import { httpClient } from '../shop/shop/shop-context';

declare var Swiper: any;

@Component({ className: 'js-product-filter-slider' })
export class ProductFilterSlider {
	filters: HTMLElement[];
	pagination: HTMLElement;
	wrapper: HTMLElement;
	instance: any;

	constructor(private element: HTMLElement) {
		this.wrapper = this.element.querySelector('.js-product-slider__wrapper');
		this.pagination = this.element.querySelector('.js-product-slider__pagination');
		this.filters = Array.from(this.element.querySelectorAll('.js-product-slider__filter'));

		if (this.wrapper && this.pagination) {
			this.init();
		}

		if (this.filters) {
			this.filters.forEach(filter => {
				filter.addEventListener('click', () => this.activateFilter(filter));
			});
		}
	}

	private init() {
		this.instance = new Swiper(this.wrapper, {
			spaceBetween: 5,
			slidesPerView: 2,
			autoHeight: false,
			breakpoints: {
				320: {
					slidesPerView: 1,
					pagination: {
						el: this.pagination,
						type: 'fraction',
						clickable: true
					},
					navigation: {
						nextEl: this.element.querySelector('.js-product-slider-next'),
						prevEl: this.element.querySelector('.js-product-slider-prev')
					}
				},
				576: {
					slidesPerView: 2,
					pagination: {
						el: this.pagination,
						type: 'fraction',
						clickable: true
					},
					navigation: {
						nextEl: this.element.querySelector('.js-product-slider-next'),
						prevEl: this.element.querySelector('.js-product-slider-prev')
					}
				},
				768: {
					pagination: {
						el: this.pagination,
						type: 'bullets',
						clickable: true
					}
				},
				992: {
					slidesPerView: 3,
					pagination: {
						el: this.pagination,
						type: 'bullets',
						clickable: true
					}
				},
				1350: {
					slidesPerView: 4,
					pagination: {
						el: this.pagination,
						type: 'bullets',
						clickable: true
					}
				}
			}
		});
	}

	private activateFilter(filter: HTMLElement) {
		if (!hasClass(filter, 'is-active')) {
			removeClass(
				this.filters.find(o => hasClass(o, 'is-active')),
				'is-active'
			);
			addClass(filter, 'is-active');
			const filterClassName = filter.getAttribute('data-val');
			if (filterClassName === 'all') {
				Array.from(this.instance.slides).forEach((o: HTMLElement) => removeClass(o, 'd-none'));
			} else {
				Array.from(this.instance.slides).forEach((o: HTMLElement) =>
					hasClass(o, filterClassName) ? removeClass(o, 'd-none') : addClass(o, 'd-none')
				);
			}
			this.instance.update();
		}
	}
}
